<template>
    <div class="table-footer">
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'app-table-footer'
    }
</script>

<style lang="scss">
    .table-footer {
        display: table-footer-group;
    }
</style>


// WEBPACK FOOTER //
// src/components/table/Footer.vue